module.exports = __webpack_public_path__ + "media/images/es/prize-generic-482482822d604e994130b8d4cdf5f1b2.png";